import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Container, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { routes } from '../common/routes';

export const SignInWithSsoSuccess = () => {
    const { t } = useTranslation();

    return (
        <StyledContainer>
            <Grid container item xs={12}>
                <TitleTypography>
                    {t('welcomeToWeatherbug')}
                </TitleTypography>
            </Grid>
            <Grid  container  item  xs={12} >
                <InfoTypography>
                    {t('youAreNowSignedIn')}
                </InfoTypography>
            </Grid>
            <Grid container item xs={12}>
                <StyledLink to={routes.logIn}>
                    <GoToSignInButton 
                        fullWidth
                        variant='outlined'
                        disableElevation
                    >
                        {t('ok')}
                    </GoToSignInButton>
                </StyledLink>
            </Grid>
        </StyledContainer>
    );
};

const StyledContainer = styled(Container)`
    margin-top: 40px;
    font: Roboto;
    font-size: 15px;
    font-weight: 400;
    font-style: normal;
    font-family: sans-serif;
`;

const TitleTypography = styled(Typography)`
    color: #000000;
    font-size: 15px;
    margin-bottom: 20px;
`;

const InfoTypography = styled(Typography)`
    color: #555555;
    font-size: 15px;
    margin: 0 auto 60px auto;
`;

const StyledLink = styled(Link)`
    text-decoration: none;
    width: 100%;
`;

const GoToSignInButton = styled(Button)`
    color: #ffffff;
    background-color: #0083C6;
`;